import defaultValue from "./defaultValue";
import validity from "./validity";
export default {
  defaultValue,
  validity,
  type: 'Multiple Choice'
};